<template>
	<div class="flex flex-col w-dvw min-h-(--min-height-custom-mobile) lg:min-h-(--min-height-custom) items-center pt-8 gap-8">
		<span class="flex text-5xl md:text-7xl w-full justify-center text-center">Q + A</span>

		<Divider class="w-32! mt-0!" />

		<!-- Didn't You Already Get Married -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">Wait...didn't you already get married?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				We did get legally married! We got the papers signed, and now we want to
				celebrate with those we love the most.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- Are Children Allowed -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">Can I bring my children?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				We love your little ones, but this will be an adult only event.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- Can Guests Bring a Plus One -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">Can I bring a plus one?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				Those invited will be directly named on your invitation. We have limited seating for both the ceremony and reception, and we
				appreciate your understanding.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- Will Transportation be Provided -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">Will transportation be provided?</span>
			<span class="w-full justify-center font-extralight! text-center">
				Unfortunately, we are unable to provide transportation for the wedding day. Depending on where you are staying, you can walk,
				Uber, or take public transportation. For all other travel questions, please refer to the
				<NuxtLink
					:to="ROUTES.travel"
					class="underline underline-offset-2 transition-all duration-150 hover:text-(--primary-brown)/75! hover:underline-offset-3"
				>
					Travel
				</NuxtLink>
				tab.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- When Should I RSVP By -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">When should I RSVP by?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				Please RSVP by May 1, 2027 so we can provide accurate numbers and meal choices to the venue and caterer. If we do not hear from
				you, we will assume you are unable to make it and you will be marked as a ‘no’.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- Dress Code -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">What is the dress code?</span>
			<span class="w-full justify-center font-extralight! text-center">
				Formal attire is required including floor length dresses and suits. Check out the
				<NuxtLink
					:to="ROUTES.dressCode"
					class="underline underline-offset-2 transition-all duration-150 hover:text-(--primary-brown)/75! hover:underline-offset-3"
				>Outfits
				</NuxtLink>
				tab for inspiration and guidance.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- When Should I Arrive -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">What time should I arrive?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				Please plan to arrive to the venue by 5:00pm to allow time to find your seat for the
				ceremony. The ceremony will start promptly at 5:30pm. Those arriving later will have
				to wait until after the ceremony to enter the venue as the outer door will be locked.
			</span>
		</div>

		<Divider class="w-32!" />

		<!-- Is the Venue Outside -->
		<div class="flex flex-col items-center gap-2 w-7/8 lg:w-2/5 ">
			<span class="flex text-xl md:text-3xl w-full justify-center text-center">Is the venue outdoors?</span>
			<span class="flex w-full justify-center font-extralight! text-center">
				There is a patio at the venue where the ceremony will take place and will be open during
				the reception. The remainder of the evening will be indoors.
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {
		Divider
	} from "primevue";

	const { ROUTES } = globalStores();
</script>

<style scoped>

</style>